import React, { useEffect, useState } from "react";
import qs from "qs";
import { Box } from "@material-ui/core";
import { translate as t } from "../../../infrastructure/translate/localization";
import { displayParameters } from "../../../usecases/benefit-model/displays/allowance/display-parameters";
import { displaySubsidyEmployees } from "../../../usecases/benefit-model/displays/allowance/display-subsidy-employees";
import useFindBenefitModels from "../../../v2/infrastructure/Benefits/hooks/queries/useFindBenefitModels";
import { GetBenefitModelsDTO } from "../../../v2/infrastructure/Benefits/types/GetBenefitModelsDTO";
import WrappedSidebarV2 from "../../../v2/ui/components/SidebarV2";

const IndividualDelivery = () => {
  const parsedQuery = qs.parse(window.location.search.replace("?", ""));
  const benefitModelId = parsedQuery["compensation-plan"];
  const recurrentSubsidy =
    parsedQuery["accumulation-type"] === "not-reportable";
  const [model, setModel] = useState<GetBenefitModelsDTO | undefined>();

  const { data } = useFindBenefitModels({});

  useEffect(() => {
    if (data) {
      setModel(data.find(({ id }) => id === benefitModelId));
    }
  }, [setModel, data, benefitModelId]);

  useEffect(() => {
    if (model) {
      displayParameters({ model, recurrentSubsidy });
      displaySubsidyEmployees({
        fromSubsidyPage: true,
        model,
        mealBenefit: model.mealBenefit,
        transportBenefit: model.transportBenefit,
        nurseryBenefit: model.nurseryBenefit,
        recurrentSubsidy,
        currentPage: 0,
      });
    }
  }, [model, recurrentSubsidy]);

  return (
    <Box pl="10rem">
      <WrappedSidebarV2 />

      <main className="section">
        <div className="section-header">
          <h1 className="section-title">
            {t("subsidy-section.subsidy-delivery")}
          </h1>
        </div>
        <div className="section-container">
          <div className="section-header">
            {recurrentSubsidy ? (
              <p className="header-title">
                {t("subsidy-section.program-subsidy")}
              </p>
            ) : (
              <p className="header-title">
                {t("subsidy-section.detail-subsidy")}
              </p>
            )}
          </div>
          <div>
            {recurrentSubsidy && (
              <p className="numerate-list">
                <span>1</span>
                {t("subsidy-section.select-benefit")}
              </p>
            )}
            <div className="container-flex" id="parameters-section-container" />
            {recurrentSubsidy && (
              <p className="numerate-list">
                <span>2</span>
                {t("subsidy-section.employee")}
              </p>
            )}
            <div
              className="container-flex"
              id="subsidy-employees-table-container"
            />
            {recurrentSubsidy && (
              <p className="numerate-list">
                <span>3</span>
                {t("subsidy-section.accept-subsidy-config")}
              </p>
            )}

            <div
              className="container-flex"
              id="information-section-container"
            />
          </div>
        </div>
        <div id="modal-container" />
      </main>
    </Box>
  );
};

export default IndividualDelivery;
